import { Button } from "@shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import React from "react";
import { useDeleteSegment } from "../../../hooks";

const SegmentDelete = ({
  openDeleteSegment,
  setOpenDeleteSegment,
  selectedSegment,
}: {
  openDeleteSegment: boolean;
  setOpenDeleteSegment: (value: boolean) => void;
  selectedSegment: any;
}) => {
  console.log(selectedSegment);
  const { mutateAsync: deleteSegment } = useDeleteSegment();
  const handleCancel = () => {
    setOpenDeleteSegment(false);
  };

  const handleSubmit = () => {
    deleteSegment(selectedSegment.id);
    setOpenDeleteSegment(false);
  };

  return (
    <div>
      {" "}
      <Dialog open={openDeleteSegment} onOpenChange={setOpenDeleteSegment}>
        <DialogContent className="max-w-xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-xl">Delete Segment</DialogTitle>
            <DialogDescription>
              Are you sure you want to delete this segment?
            </DialogDescription>
          </DialogHeader>

          <div className="mt-4">
            <p className="text-sm text-muted-foreground">
              Are you sure you want to delete the segment "{selectedSegment?.name}"? This will permanently remove the system and all its
              associated data. This action cannot be undone.
            </p>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={handleCancel}>
              Cancel
            </Button>
            <Button onClick={handleSubmit}>Delete</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SegmentDelete;
